import AvisoSnack from './AvisoSnack';

export default AvisoSnack;